// tslint:disable:variable-name
import { createContext } from 'react';
import { IContextValue } from './interfaces';
import { TContext } from './types';

export const Context: TContext = createContext<IContextValue>(null);
